


































































































import DigitalTransform from "vue-digital-transform";
import FilteringMain from "@/components/FilteringMainv2.vue";
import UsersColors from "@/constants/usersColors";
import ApiService from "@/services/ApiService";
import LabelHorizontal from "@/components/travel_planning/LabelHorizontal.vue";
import LabelVertical from "@/components/travel_planning/LabelVertical.vue";

export default {
  components: {
    DigitalTransform,
    FilteringMain,
    LabelVertical,
    LabelHorizontal,
  },
  data() {
    return {
      filterOptions: {},
      loading: false,
      chartData: {
        columns: ["date", "staff", "parent"],
        rows: [
          {
            date: "01/01",
            staff: 12,
            parent: 14,
          },
          {
            date: "01/02",
            staff: 5,
            parent: 54,
          },
          {
            date: "01/03",
            staff: 19,
            parent: 24,
          },
          {
            date: "01/04",
            staff: 19,
            parent: 24,
          },
          {
            date: "01/05",
            staff: 19,
            parent: 24,
          },
          {
            date: "01/06",
            staff: 19,
            parent: 24,
          },
          {
            date: "01/07",
            staff: 19,
            parent: 24,
          },
          {
            date: "01/08",
            staff: 19,
            parent: 24,
          },
          {
            date: "01/09",
            staff: 19,
            parent: 24,
          },
        ],
      },
      colors: { ...UsersColors },
      number: 523,
      stats: {
        total_parents: 0,
        total_staff: 0,
        total_children: 0,
        total_users: 0,
      },
      interval: 300,
      selection: [],
      schools: [],
      activeTab: "first",
      signupsInfoModal: "",
    };
  },
  methods: {
    updateMainFilter(data) {
      this.loading = true;
      this.filterOptions = data;
      ApiService.generalApi.getSignupData(data).then((response: any) => {
        this.stats = response.data.data;
        this.loading = false;
      });
    },
    goto(page: string) {
      this.$router.push({ name: page });
    },
    showModal() {
      this.loading = true;
      this.$modal.show("infoModal");
      ApiService.generalApi.increaseSignupsInfo().then((resp) => {
        this.signupsInfoModal = resp.data;
        this.loading = false;
      });
    },
    closeModal() {
      this.$modal.hide("infoModal");
    },
  },
  computed: {
    userSignupsData: function () {
      if (this.stats) {
        return {
          columns: ["date", "staff", "parents"],
          rows: this.stats.usersByDay,
        };
      } else {
        return null;
      }
    },
    pupilsBySchoolYear: function () {
      return {
        columns: ["year", "count"],
        rows: this.stats.pupilsBySchoolYear,
      };
    },
    accType: function () {
      return this.$store.state.accType;
    },
  },
};
